module.exports = __webpack_public_path__ + "static/img/home6.d0d358d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/home6.gif
// module id = Si79
// module chunks = 0